import { useEffect } from 'react'
import firebase from 'firebase/compat/app'
import { useAppSelector } from '../redux'
import { useUser } from '.'

export const UserContext = () => {
  const { user: cU } = useAppSelector((state) => state.user)
  const { load, logout } = useUser()

  useEffect(
    () =>
      firebase.auth().onAuthStateChanged(async (user) => {
        if (!user && !!cU) {
          return logout()
        }

        await load()
      }),
    []
  )

  return null
}
